import React from 'react';
import { StoreMap } from '~/features/find-store/components/StoreMap';
import { Modules, P71StoreDetailsPage as StorePageProps } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks';
import styles from './P71StoreDetailsPage.module.scss';

export const P71StoreDetailsPage = (props: StorePageProps) => {
    const { storeId, data: pageData } = props;

    const store = pageData?.storeList?.data?.find((x) => x.id == storeId);

    if (!store) {
        return null;
    }

    return (
        <>
            <div className={styles.storeDetailsContainer}>
                <div className={styles.storeDetailsContent}>
                    <StoreMap store={store} />
                </div>
            </div>

            <DynamicBlockList elements={props.bottomPageElements as Modules[]} />
        </>
    );
};
